import React from "react";
import { NO, YES } from "../../lib/choices";
import { ThirdAnswer } from "../../lib/types";

interface IThirdQuestionProps {
  value: ThirdAnswer;
  text: string;
  setValue: (value: ThirdAnswer) => void;
}

/** Display second question */
const Thirdq = ({
  value,
  setValue,
  text,
}: IThirdQuestionProps): JSX.Element => {
  /** Check users key press */
  const handleKeyPress = (event: React.KeyboardEvent<HTMLButtonElement>) => {
    if (event.key === "y") {
      setValue(YES);
    }
    if (event.key === "n") {
      setValue(NO);
    }
  };

  return (
    <section className="third-section">
      <h2>{text}</h2>
      <div className="choices-form">
        <div className="choices-layout">
          <ul className="choices-list">
            <li>
              <button
                type="button"
                className="list-item"
                onClick={() => setValue(YES)}
                tabIndex={0}
                onKeyPress={(e) => handleKeyPress(e)}
              >
                {value === YES ? <div className="selected" /> : null}
                <div className="instructions">
                  <div className={`key ${value === YES ? "selected-key" : ""}`}>
                    Y
                  </div>
                  <p>{YES}</p>
                </div>
              </button>
            </li>
            <li>
              <button
                type="button"
                className="list-item"
                onClick={() => setValue(NO)}
                tabIndex={0}
                onKeyPress={(e) => handleKeyPress(e)}
              >
                {value === NO ? <div className="selected" /> : null}
                <div className="instructions">
                  <div className={`key ${value === NO ? "selected-key" : ""}`}>
                    N
                  </div>
                  <p>{NO}</p>
                </div>
              </button>
            </li>
          </ul>
        </div>

        {!!value && (
          <button className="orange-button" tabIndex={0} type="submit">
            SUBMIT
          </button>
        )}
      </div>
    </section>
  );
};

export default Thirdq;
